import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ResizeObserver from 'resize-observer-polyfill';
import { isElementOverflown } from '@lt/components/utils/userflow';

const StyledContainer = styled.div`
  position: relative;
  display: inline-block;
  overflow: hidden;
  white-space: pre;

  ${({ theme, showFade, fadeColor }) =>
    showFade &&
    css`
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        width: 90px;
        height: 100%;
        content: '';
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          ${fadeColor || theme.colors.white} 75%
        );
      }
    `}
`;

const overflowOptions = {
  horizontal: true,
  vertical: false,
};

const FadedOneLineText = ({ children, smartFade, ...props }) => {
  const wrapeprEl = useRef(null);
  const [isOverflown, setIsOverflown] = useState(!smartFade);

  if (smartFade) {
    let observer = null;

    const handleOverflow = () => {
      setIsOverflown(isElementOverflown(wrapeprEl.current, overflowOptions));
    };

    // TODO: Fix conditional useEffect
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      observer = new ResizeObserver(handleOverflow);
      observer.observe(wrapeprEl.current);
      return () => {
        if (observer) {
          observer.unobserve(wrapeprEl.current);
        }
      };
    }, []);
  }

  return (
    <StyledContainer ref={wrapeprEl} showFade={isOverflown} {...props}>
      {children}
    </StyledContainer>
  );
};

FadedOneLineText.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  fadeColor: PropTypes.string,
  smartFade: PropTypes.bool,
};

FadedOneLineText.defaultProps = {
  className: '',
  fadeColor: null,
  smartFade: false,
};

export default FadedOneLineText;
